
export default {
  name: 'SingleStepController',
  data() {
    return {

    }
  },
  render() {
    return this.$scopedSlots.default({

    })
  },
}
